interface urlType {
    currlist: string
}
const url: urlType = {
    // 课程分类
    currlist:'api/webApi/course/cateLst'
}
export default url